import React, { useState } from "react"
import { Bell } from "lucide-react"
import { Button } from "src/components/ui/button"
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "src/components/ui/alert-dialog"
import { useToast } from "src/components/ui/toast"
import { useRemindInstallment } from "../hooks/useCollectionMutations"

export default function RemindButton({ installmentId, customerName, onSuccess }) {
  const [open, setOpen] = useState(false)
  const { mutate, isPending } = useRemindInstallment()
  const { toast } = useToast()

  async function handleConfirm() {
    try {
      await mutate(installmentId)
      toast({ title: "Reminder sent", description: `Payment reminder sent to ${customerName}.` })
      setOpen(false)
      onSuccess?.()
    } catch (errors) {
      toast({ variant: "destructive", title: "Error", description: errors?.[0] || "Failed to send reminder" })
    }
  }

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogTrigger asChild>
        <Button variant="ghost" size="sm" className="h-7 gap-1 px-2 text-[12px]">
          <Bell className="h-3.5 w-3.5" />
          Remind
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Send payment reminder?</AlertDialogTitle>
          <AlertDialogDescription>
            This will send a payment reminder to {customerName}. The reminder is logged and won't be sent again for this installment.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={handleConfirm} disabled={isPending}>
            {isPending ? "Sending…" : "Send Reminder"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
